export default {
  title: '¡Invita a tus colegas!',
  title2: 'Puedes invitar hasta <b>4 colegas de tu Escuela</b> para que disfruten juntos la plataforma.',
  emailPlaceholder: 'nombre@mail.com',
  cancelButton: 'Cancelar',
  sendButton: 'Enviar',
  invalidEmailError: 'Correo inválido. Prueba formato nombre@mail.com',
  usedEmailError: 'Ya fue invitado. Elige a otro colega de tu Escuela.',
  invitationsSentTitle: '¡Invitaciones enviadas!',
  invitationsSentSubtitle: 'Tus colegas recibirán un mail de invitación.',
  invitationResendTitle: '¡Invitación reenviada!'
}

export const en = {
  title: 'Invite your colleagues!',
  title2: 'You can invite up to <b>4 School colleagues</b> so you can enjoy the platform together.',
  emailPlaceholder: 'name@mail.com',
  cancelButton: 'Cancel',
  sendButton: 'Send',
  invalidEmailError: 'Invalid email. Try format name@mail.com',
  usedEmailError: 'Already invited. Pick another colleague from your School.',
  invitationsSentTitle: '¡Invitations sent!',
  invitationsSentSubtitle: 'Your colleagues will receive an invitation mail.'
}

export const ca = {
  title: 'Convida els teus companys!',
  title2: 'Pots convidar fins a <b>4 companys de la teva Escola</b> per aprofitar junts la plataforma.',
  emailPlaceholder: 'nom@mail.com',
  cancelButton: 'Cancel·la',
  sendButton: 'Envia',
  invalidEmailError: 'Correu invàlid. Prova de format nombre@mail.com',
  usedEmailError: 'Ja l\'han convidat. Tria a un altre company de la teva Escola.',
  invitationsSentTitle: 'Invitacions enviades!',
  invitationsSentSubtitle: 'Els teus companys rebran un correu electrònic d\'invitació.'
}
